import firebase from "firebase/compat/app";
import db from ".";
import TemplateLanguage, { accountData } from "../../src/app/models/Language";
import Template from "../../src/app/models/Template";
import { createRef } from "./connection";
import { converter2 } from "./converter";
// import Language as Languagev2 from "../app/models/Language";
import Company from "../app/models/Company";
import * as lc from "../app/modules/localstorage/index";
import * as conn from "./connection";
import { UserCompanies } from "../app/models/User";
import * as Log from "src/util/SDayslogger"

export const getListTemplateInteractive = async (companyID: string, client: string, language: string, limit?: number) => {
  let query = db
    .collection("templates")
    .where("client", "==", createRef("clients", client))
    // .where("companies", "array-contains", createRef("company", companyID))
    .where("isActive", "==", true)
    .where("category", "==", "interactive") //TODO Filter interactive only
    .orderBy("priority")
    .orderBy("createdAt", "desc");

  // if (limit) {
  //   query = query.limit(limit);
  // }

  return await query
    .withConverter(converter2<Template>())
    .get()
    .then(async (snapshot) => {

      Log.info(`found #${snapshot.docs.length} interactive template`)

      const templates: Template[] = await Promise.all(
        snapshot.docs.map(async (doc) => {
          const data = doc.data();

          const languageDoc = await doc.ref
            .collection("languages")
            .where("language","==",language)
            // .doc(language)
            .withConverter(converter2<TemplateLanguage>())
            .get()
            .then((snaps) => {

              if (snaps.size<=0)
                return undefined

              const doc = snaps.docs[0]
              if (!doc.exists) 
                return undefined;  

              return { ...doc.data(), id: doc.id };
            });

          return {
            ...data,
            id: doc.id,
            languagesModel: languageDoc ? [languageDoc] : [],
          };
        })
      );

      Log.info(`found & processed #${templates.length} interactive template`)
      return templates.filter((template: Template) => template.languagesModel && template.languagesModel.length > 0);
    });
};

export const getByAccount = async (clientId: string, accountId: string) => {
  console.log(`getByAccount ${accountId} client:${clientId}`);
  const query = db
    .collection("templates")
    .withConverter(converter2<Template>())
    .where("client", "==", createRef("clients", clientId))
    .where("accounts", "array-contains", createRef("account", accountId));

  return query
    .get()
    .then((snapshot) => {
      const templates = snapshot.docs.map((doc) => {
        return { ...doc.data(), id: doc.id } as Template;
      });
      console.log(templates, "templates sor");
      return templates;
    })
    .catch((error) => {
      console.error(`query getByAccount ${error}`);
      return [] as Template[];
    });
};

export const getAccessibleTemplate = async (clientId: string, companyAccess: UserCompanies[]) => {
  let query = db
    .collection("templates")
    .withConverter(converter2<Template>())
    .where("isActive", "==", true)
    .where("client", "==", createRef("clients", clientId));

  console.log(`get accessible template `, companyAccess.length);

  const hasAllCompanyAccess = companyAccess.find((accessCompany) => accessCompany.id === "*");
  //if user does not have access to all company, get by company
  if (!hasAllCompanyAccess) {
    companyAccess.forEach((company) => {
      const ref = createRef("company", company.id);
      query = query.where("companies", "array-contains", ref);
    });
  }

  console.log(`get accessible template filter`, query);

  return query
    .get()
    .then((snapshot) => {
      const templates = snapshot.docs.map((doc) => {
        return { ...doc.data(), id: doc.id } as Template;
      });
      return templates;
    })
    .catch((error) => {
      console.error(`query getByAccount ${error}`);
      return [] as Template[];
    });
};

export const fecthTemplateByNameAndClient = async (templateName: string, clientID: string) => {
  const client = createRef("clients", clientID);
  return await db
    .collection("templates")
    .where("client", "==", client)
    .where("isActive", "==", true)
    .where("templateName", "==", templateName)
    .withConverter(converter2<Template>())
    .limit(1)
    .get()
    .then((snaps) => {
      const templateList = snaps.docs.map((doc) => ({
        id: doc.id,
        data: doc.data(),
      }));
      console.log("templateList : " + templateList);
      return templateList;
    })
    .catch((error) => {
      //TODO
      console.log("Erorr fetchTemplateByTemplateNameAndClient : " + error);
    });
};

// Multi-language support: Check for template by name only (without language filter)
export const fetchTemplateByNameOnly = async (templateName: string, clientID: string) => {
  const client = createRef("clients", clientID);
  console.log(`[Multi-Language] Checking for existing template with name: ${templateName}`);
  
  return await db
    .collection("templates")
    .where("client", "==", client)
    .where("isActive", "==", true)
    .where("templateName", "==", templateName)
    .withConverter(converter2<Template>())
    .limit(1)
    .get()
    .then((snaps) => {
      if (snaps.docs.length > 0) {
        const template = snaps.docs[0];
        console.log(`[Multi-Language] Found existing template with ID: ${template.id}`);
        return {
          id: template.id,
          data: template.data(),
        };
      } else {
        console.log(`[Multi-Language] No existing template found with name: ${templateName}`);
        return null;
      }
    })
    .catch((error) => {
      console.error("Error fetchTemplateByNameOnly: " + error);
      return null;
    });
};

export const getTemplateLanguages = async (templateID: string) => {
  return await db
    .collection("templates")
    .doc(templateID)
    .collection("languages")
    // .where("status","in",["APPROVED", "approved"])
    .withConverter(converter2<TemplateLanguage>())
    .get()
    .then((snapshot) => {
      const languages = snapshot.docs.map((doc) => {
        return { ...doc.data(), id: doc.id };
      });
      return Promise.all(languages);
      // return languages;
    })
    .catch((err) => {
      console.log("Error set languages in template : ", err);
      return Promise.reject();
    });
};

export const get = async (templateID: string) =>
  await db
    .collection("templates")
    .doc(templateID)
    .withConverter(converter2<Template>())
    .get()
    .then((snapshot) => ({ id: snapshot.id, ...snapshot.data() }))
    .catch((err) => {
      console.log("Error getting documents (getDataTemplateByID)", err);
    });

export const createTemplate = async (templateData: any) => {
  let templateId;
  console.log(templateData, "Create New Template in Firebase xll");

  await db
    .collection("templates")
    .add(templateData)
    .then((ref) => {
      console.log(templateData, "isi template data rui");
      templateId = ref.id;
      return ref.id;
    })
    .catch((error) => {
      console.error("Error adding document: ", error);
    });
  return templateId;
};

export const updateTemplate = async (templateData: any, templateID: string) => {
  console.log("Check Data UPDATE :: " + JSON.stringify(templateData));
  let template: Template = Object.fromEntries(Object.entries(templateData as Template).filter(([key]) => !key.includes("id")));

  console.log("Check Data UPDATE 2 :: " + JSON.stringify(template));
  return await db
    .collection("templates")
    .doc(templateID)
    .set({ ...template }, { merge: false })
    // .update(template)
    .then((doc) => {
      console.log("Updated: " + doc);
    })
    .catch((err) => {
      console.log("Error updateTemplate : ", err);
    });
};

export const updateLanguage = async (templateId: string, languageID: string, languageData: any) => {
  console.log("Check Language Data : " + JSON.stringify(languageData));
  let language = languageData as TemplateLanguage;
  language = Object.fromEntries(Object.entries(language).filter(([key]) => !key.includes("id")));

  // Sanitize data to remove undefined values that cause Firebase errors
  const sanitizedLanguage = removeUndefinedValues(language);
  console.log(sanitizedLanguage, "sanitized language rui");
  console.log(languageID, "languageID rui");
  
  return await db
    .collection("templates")
    .doc(templateId)
    .collection("languages")
    .doc(languageID)
    .set(sanitizedLanguage)
    .then((doc) => {
      console.log("Updated: " + doc);
    })
    .catch((err) => {
      console.log("Error updateLanguage : ", err);
    });
};

// Utility function to recursively remove undefined values from objects
const removeUndefinedValues = (obj: any): any => {
  if (obj === null || obj === undefined) {
    return obj;
  }
  
  if (Array.isArray(obj)) {
    return obj.map(removeUndefinedValues).filter(item => item !== undefined);
  }
  
  if (typeof obj === 'object') {
    const cleaned: any = {};
    Object.keys(obj).forEach(key => {
      const value = removeUndefinedValues(obj[key]);
      if (value !== undefined) {
        cleaned[key] = value;
      }
    });
    return cleaned;
  }
  
  return obj;
};

export const addCampaignLanguage = async (templateId: string, languageID: string, languageData: any) => {
  console.log("running addCampaignLanguage() rpm")
  
  // Sanitize data to remove undefined values that cause Firebase errors
  const sanitizedData = removeUndefinedValues(languageData);
  console.log("Sanitized language data before Firebase write:", JSON.stringify(sanitizedData));
  
  return await db
    .collection("templates")
    .doc(templateId)
    .collection("languages")
    .doc(languageID)
    // .set({...languageData})
    .set(sanitizedData, { merge: false })
    .then((doc) => {
      console.log("Added: " + doc);
      return languageID;
    })
    .catch((err) => {
      console.log("Error set languages in template : ", err);
    });
};

// Multi-language support: Add language to existing template
export const addLanguageToExistingTemplate = async (templateId: string, languageID: string, languageData: any, accountData?: any) => {
  console.log(`[Multi-Language] Adding language ${languageID} to existing template ${templateId}`);
  
  try {
    // Check if this language already exists for the template
    const existingLanguage = await db
      .collection("templates")
      .doc(templateId)
      .collection("languages")
      .doc(languageID)
      .get();
    
    if (existingLanguage.exists) {
      console.log(`[Multi-Language] Language ${languageID} already exists for template ${templateId}`);
      return { success: false, message: "Language already exists for this template" };
    }
    
    // Sanitize data to remove undefined values
    const sanitizedData = removeUndefinedValues(languageData);
    console.log(`[Multi-Language] Sanitized language data:`, JSON.stringify(sanitizedData));
    
    // Add the language subcollection document
    const result = await addCampaignLanguage(templateId, languageID, sanitizedData);
    
    if (result) {
      // Update the main template's languages array
      const templateDoc = await db.collection("templates").doc(templateId).get();
      if (templateDoc.exists) {
        const templateData = templateDoc.data();
        const currentLanguages = templateData?.languages || [];
        
        // Check if language already exists in array
        const existingLangIndex = currentLanguages.findIndex((l: any) => l.templateLanguage === languageData.language);
        
        if (existingLangIndex < 0) {
          // Add new language to array with proper account field
          // 🔧 FIX: Use accountData from server response or existing template structure
          let accountRef = null;
          
          // Try to get account from server's accountData if available
          if (accountData && accountData.accountId) {
            accountRef = createRef("account", accountData.accountId);
            console.log(`[Multi-Language] Using server accountId to create proper DocumentReference:`, accountRef);
          } else if (languageData.accountData && languageData.accountData.accountId) {
            accountRef = createRef("account", languageData.accountData.accountId);
            console.log(`[Multi-Language] Using languageData accountId to create proper DocumentReference:`, accountRef);
          } else if (currentLanguages.length > 0 && currentLanguages[0].account) {
            // Fallback: use account from existing language entries
            accountRef = currentLanguages[0].account;
            console.log(`[Multi-Language] Using existing template accountRef:`, accountRef);
          } else {
            console.error(`[Multi-Language] ❌ No account reference available for language ${languageData.language}`);
            console.error(`[Multi-Language] Debug info - accountData:`, accountData);
            console.error(`[Multi-Language] Debug info - languageData.accountData:`, languageData.accountData);
            console.error(`[Multi-Language] Debug info - currentLanguages:`, currentLanguages);
          }
          
          currentLanguages.push({
            templateLanguage: languageData.language,
            templateStatus: languageData.status || "PENDING",
            account: accountRef // 🔧 FIX: Include account field for consistency
          });
          
          // Update template document
          await db.collection("templates").doc(templateId).update({
            languages: currentLanguages,
            updatedAt: new Date()
          });
          
          console.log(`[Multi-Language] Successfully added language ${languageID} to template ${templateId}`);
        }
      }
      
      return { 
        success: true, 
        templateId: templateId,
        languageId: result
      };
    } else {
      return { success: false, message: "Failed to create language subcollection" };
    }
  } catch (error) {
    console.error(`[Multi-Language] Error adding language to template:`, error);
    return { success: false, message: "Internal error adding language to template" };
  }
};

export const getTemplateAccounts = async (templateID: string, languageID: string) => {
  if (!templateID || !languageID) return;

  return await db
    .collection("templates")
    .doc(templateID)
    .collection("languages")
    .doc(languageID)
    .collection("templateAccounts")
    .withConverter(converter2<accountData>())
    .get()
    .then((snapshot: any) => {
      console.log("komen templateID getTemplateAccounts : ", templateID);
      console.log("komen languageID getTemplateAccounts : ", languageID);
      console.log("masuk sini getTemplateAccounts");
      console.log(`komen snapshot `, snapshot);
      const templateAccounts = snapshot.docs.map((doc: any) => ({
        ...doc.data(),
        id: doc.id,
      }));
      console.log(templateAccounts, "templateAccounts komen");

      return templateAccounts;
    })
    .catch((err) => {
      console.log("Error get languages in template : ", err);
      return Promise.reject();
    });
};

export const updateTemplateAccounts = async (templateID: string, languageID: string, template: any) => {
  if (!templateID || !languageID || !template.id) return;
  const templateAccountID = template.id;
  delete template.id;
  return await db
    .collection("templates")
    .doc(templateID)
    .collection("languages")
    .doc(languageID)
    .collection("templateAccounts")
    .doc(templateAccountID)
    .set({ ...template }, { merge: true })
    .then((snaps) => {
      console.log(`success create or update template accounts`);
    })
    .catch((error: any) => {
      console.log("Error create or update template accounts` : " + error);
    });
};

export const createTemplateAccounts = async (templateID: string, languageID: string, template: any) => {
  if (!templateID || !languageID) return;

  return await db
    .collection("templates")
    .doc(templateID)
    .collection("languages")
    .doc(languageID)
    .collection("templateAccounts")
    .add({
      ...template,
    })
    .then((snaps) => {
      console.log(`success create or create template accounts`);
    })
    .catch((error: any) => {
      console.log("Error create or create template accounts` : " + error);
    });
};

export const deleteTemplatebyId = (id: string) => db.collection("templates").doc(id).update({ isActive: false, updatedAt: new Date() });
